import Vue from "vue";
import Router from "vue-router";

// ALL
import Products from "./views/all/Products.vue";
import Login from "./views/all/Login.vue";
import Parameters from "./views/all/Parameters.vue";
import Settings from "./views/all/Settings.vue";
import Support from "./views/all/Support.vue";
import ServiceApp from "./views/all/ServiceApp.vue";
import Upgrade from "./notused/Upgrade.vue";

// EVCS
import EVCSDashboard from "./views/evcs/Dashboard.vue";

// ESCB
import ESCBDashboard from "./views/escb/Dashboard.vue";
import ESCBPieCharts from "./views/escb/PieCharts.vue";
import ESCBCharts from "./views/escb/Charts.vue";
import ESCBSavings from "./views/escb/Savings.vue";

// EESS
import EESSBasic from "./views/eess/Basic.vue";
import EESSDashboard from "./views/eess/Dashboard.vue";
import EESSPieCharts from "./views/eess/PieCharts.vue"; /* Ještě je používá dashboard EESS -> nahradit časem */
import EESSPieCharts2 from "./views/eess/PieCharts2.vue";
import EESSCharts from "./views/eess/Charts.vue";
import EESSPowerPlant from "./views/eess/PowerPlant.vue";
import EESSPPDS from "./views/eess/PPDS.vue";
import EESSSavings from "./views/eess/Savings.vue";
import EESSBattery from "./views/eess/Battery.vue";
import EESSEvents from "./views/eess/Events.vue";
import EESSCalibration from "./views/eess/Calibration.vue";
import EESSAdvanced from "./views/eess/Advanced.vue";
import EESSUserInterface from "./views/eess/UserInterface.vue";

import Notifications from "./views/all/Notifications.vue";

import i18n from "./i18n";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: `/${i18n.locale}/login`,
    },
    {
      path: "/:lang",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "products",
          name: "products",
          component: Products,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "login",
          name: "login",
          component: Login,
          meta: {
            title: "Login",
          },
        },
        {
          path: "parameters",
          name: "parameters",
          component: Parameters,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "settings",
          name: "settings",
          component: Settings,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "support",
          name: "support",
          component: Support,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "upgrade",
          name: "upgrade",
          component: Upgrade,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "serviceapp",
          name: "serviceapp",
          component: ServiceApp,
          meta: {
            title: "EDS",
          },
        },
        {
          path: "evcs-dashboard",
          name: "evcs-dashboard",
          component: EVCSDashboard,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "escb-dashboard",
          name: "escb-dashboard",
          component: ESCBDashboard,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "escb-piecharts",
          name: "escb-piecharts",
          component: ESCBPieCharts,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "escb-charts",
          name: "escb-charts",
          component: ESCBCharts,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "escb-savings",
          name: "escb-savings",
          component: ESCBSavings,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-basic",
          name: "eess-basic",
          component: EESSBasic,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-dashboard",
          name: "eess-dashboard",
          component: EESSDashboard,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-piecharts",
          name: "eess-piecharts",
          component: EESSPieCharts,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-piecharts2",
          name: "eess-piecharts2",
          component: EESSPieCharts2,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-charts",
          name: "eess-charts",
          component: EESSCharts,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-powerplant",
          name: "eess-powerplant",
          component: EESSPowerPlant,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-ppds",
          name: "eess-ppds",
          component: EESSPPDS,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-savings",
          name: "eess-savings",
          component: EESSSavings,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-battery",
          name: "eess-battery",
          component: EESSBattery,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-events",
          name: "eess-events",
          component: EESSEvents,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-calibration",
          name: "eess-calibration",
          component: EESSCalibration,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-advanced",
          name: "eess-advanced",
          component: EESSAdvanced,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "eess-userinterface",
          name: "eess-userinterface",
          component: EESSUserInterface,
          meta: {
            title: "EnergyCloud",
          },
        },
        {
          path: "notifications",
          name: "notifications",
          component: Notifications,
          meta: {
            title: "EnergyCloud",
          },
        },
        // otherwise redirect to login
        { path: "*", redirect: "login" },
      ],
    },
  ],
});

Router.prototype.open = function (routeObject) {
  const { href } = this.resolve(routeObject);
  window.open(href, "_blank");
};

// TODO dvě metody stejné jedna v router druhá v app!!
/* router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  if (!language) {
    language = "en";
  }
  i18n.locale = language;
  next();
}); */

router.beforeEach((to, from, next) => {
  document.title = to.meta?.title ?? "Application";

  const publicPages = [`/${i18n.locale}/login`, `/${i18n.locale}/serviceapp`];

  const nextAllowed = publicPages.includes(to.path);
  const authRequired = !publicPages.includes(to.path);

  if (nextAllowed) {
    return next();
  }

  const loggedIn = sessionStorage.getItem("user");

  if (authRequired && !loggedIn) {
    return next(`/${i18n.locale}/login`);
  }

  next();
});
